(function ($) {
  $('.projects__slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button class="projects__nav projects__nav--prev" aria-label="Vorige projecten"></button>',
    nextArrow: '<button class="projects__nav projects__nav--next" aria-label="Volgende projecten"></button>',
    infinite: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
}(jQuery));
